/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const URI = require('urijs');

window.DocumentSetsDocuments = {
  _gridApi: null,

  _gridOptions: {
    rowData: null,
    rowHeight: 98,
    suppressRowTransform: true,
    headerHeight: 0,
    rowBuffer: 1000,
    domLayout: 'autoHeight',
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridReady(event) {
      return event.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    }
  },

  documentsLocks: [],

  _showOnDropDown(target) {
    target.parents('ul').find('a').removeClass('selected');
    target.addClass('selected');
    return target.parents('ul').parent().find('span').text(target.html());
  },

  _refreshDocumentsLocks() {
    return _.each(DocumentSetsDocuments.documentsLocks, function (documentLock) {
      switch (documentLock.clazz) {
        case 'pt-lock': return $('#' + documentLock.document_id).removeClass('pt-lock pt-unlock').addClass('pt-lock');
        case 'pt-unlock': return $('#' + documentLock.document_id).removeClass('pt-lock pt-unlock').addClass('pt-unlock');
      }
    });
  },

  _resetSelectAllCheckBox() {
    $('#select-all-documents').prop('checked', false);
    return $('.dropdown-document-actions').attr('disabled', true);
  },

  _sort(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const name = $target.data('sort-name');
    this._showOnDropDown($target);
    const currentSort = this._gridApi.getColumnState().filter(c => c.sort);
    const direction = currentSort.length > 0 ?
      currentSort[0].sort === 'asc' ? 'desc' : 'asc'
      :
      'asc';
    const sort = [{ colId: name, sort: direction }];
    this._gridApi.applyColumnState({ state: sort, defaultState: { sort: null } });
    this._gridApi.redrawRows();
    this._refreshDocumentsLocks();
    return this._resetSelectAllCheckBox();
  },

  _filter(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    this._showOnDropDown($target);
    const name = $target.data('filter-name');
    const value = $target.data('filter-value');
    const filter = this._gridApi.getFilterInstance(name);
    const model = value ?
      { type: 'equals', filter: value }
      :
      { type: 'notEquals', filter: '' };
    filter.setModel(model);
    return this._gridApi.onFilterChanged();
  },

  _onHideDocument(e, response) {
    const $target = $(e.currentTarget);
    if (response.document_versions_exists) {
      if (response.internal) {
        $target.removeClass($target.data('internal-false-class')).addClass($target.data('internal-true-class'));
        $target.attr('title', $target.data('internal-true-title'));
      } else {
        $target.removeClass($target.data('internal-true-class')).addClass($target.data('internal-false-class'));
        $target.attr('title', $target.data('internal-false-title'));
      }
    }
    $('.left-sidebar-bids').attr('disabled', !response.show_post);
    if (response.show_post) {
      return $('.left-sidebar-bids').removeClass('disabled');
    } else {
      return $('.left-sidebar-bids').addClass('disabled');
    }
  },

  _isBulkDownloadEnabled() {
    const accessibleStates = this._selectedDocumentIds().map(id => $(`input[type='hidden']#document_${id}`).val());
    return accessibleStates.every(state => state === 'true');
  },

  _onSelectDocument() {
    $('.dropdown-document-actions').attr('disabled', $('.select-document:checked').length === 0);
    return $('#download-documents-action').toggleClass('disabled', !this._isBulkDownloadEnabled());
  },

  _selectedDocumentIds() {
    const selectedDocuments = $('.select-document:checked').map(function () { return $(this).val(); });
    return selectedDocuments.toArray();
  },

  _selectedDocumentsIds(event) {
    const selectedDocuments = $('.select-document:checked').not('.certificate-document, .form-of-tender').map(function () { return $(this).val(); });
    return selectedDocuments.toArray();
  },

  _selectedCertificateIds(event) {
    const selectedCertificates = $('.certificate-document:checked').map(function () { return $(this).val(); });
    return selectedCertificates.toArray();
  },

  _selectedFormOfTenderId(event) {
    const selectedFormOfTender = $('.select-document.form-of-tender:checked').map(function () { return $(this).val(); });
    return selectedFormOfTender.toArray();
  },

  _onDownloadDocuments(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const params = { selected_ids: this._selectedDocumentIds().join() };

    if (this._isBulkDownloadEnabled()) {
      return location.href = this._buildURLWithParams($target.attr('href'), params);
    }
  },

  _onMoveDocumentsAction(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    return $('#modalContent').foundation('reveal', 'open', {
      url: this._buildURLWithParams($target.attr('href'), { selected_ids: this._selectedDocumentIds().join() })
    });
  },

  _buildURLWithParams(href, params) {
    let separator = "?";
    if (href.indexOf('?') !== (-1)) { separator = "&"; }
    return `${href}${separator}${$.param(params)}`;
  },

  _onSelectCategoryToMove(event) {
    const $target = $(event.currentTarget);
    const isNew = ($target.val() === 'new');
    return $('#move-new-document-category').toggleClass('hide', !isNew).find('input, select').prop('disabled', !isNew);
  },

  _onAcceptDocuments(event) {
    event.preventDefault();
    event.stopPropagation();
    _.each(this._selectedDocumentsIds(), id => $('#accept-documents-form #selected-ids-example').clone().prop('id', `selected-ids-${id}`).removeAttr('disabled').val(id).appendTo("#accept-documents-form"));
    return $('#accept-documents-form').submit();
  },

  _onBulkStartReview(event, redirectToDownload) {
    if (redirectToDownload == null) { redirectToDownload = false; }
    event.preventDefault();
    event.stopPropagation();
    _.each(this._selectedDocumentIds(), function (id) {
      const reviewId = $('#review-id-for-document-' + id).data('review-id');
      $('#bulk-start-review-form #selected-ids-for-bulk-start-review').clone().prop('id', `selected-ids-${id}`).removeAttr('disabled').val(reviewId).appendTo("#bulk-start-review-form");
      return $('#bulk-start-review-form #selected-ids-for-bulk-start-review').clone().prop('name', 'selected_document_ids[]').prop('id', `selected-document-ids-${id}`).removeAttr('disabled').val(id).appendTo("#bulk-start-review-form");
    });
    if (redirectToDownload) { $("<input name='redirect_to_download' value='true'/>").appendTo("#bulk-start-review-form"); }
    return $('#bulk-start-review-form').submit();
  },

  _onBulkDownloadAndReview(e) {
    e.preventDefault();
    e.stopPropagation();

    return this._onBulkStartReview(e, { redirectToDownload: true });
  },

  _onBulkDestroyDocuments(event) {
    event.preventDefault();
    event.stopPropagation();
    _.each(this._selectedDocumentsIds(), id => $('#bulk-destroy-form #selected-ids-for-destroy').clone().prop('id', `selected-ids-${id}`).removeAttr('disabled').val(id).appendTo("#bulk-destroy-form"));
    _.each(this._selectedCertificateIds(), id => $('#bulk-destroy-form #selected-certificate-ids-for-destroy').clone().prop('id', `selected-ids-${id}`).removeAttr('disabled').val(id).appendTo("#bulk-destroy-form"));
    _.each(this._selectedFormOfTenderId(), id => $('#bulk-destroy-form #selected-form-of-tender-id-for-destroy').clone().prop('id', `selected-ids-${id}`).removeAttr('disabled').val(id).appendTo("#bulk-destroy-form"));
    return $('#bulk-destroy-form').submit();
  },

  _onSelectAllDocuments(event) {
    const isChecked = $(event.currentTarget).is(':checked');
    $('.select-document').prop('checked', isChecked);
    if ($('.select-document').length > 0) {
      $('.dropdown-document-actions').attr('disabled', !isChecked);
      return $('#download-documents-action').toggleClass('disabled', !this._isBulkDownloadEnabled());
    }
  },

  _updateDocumentsLocks(id, clazz) {
    const doc = _.find(DocumentSetsDocuments.documentsLocks, documentLock => documentLock.document_id === id);
    if (doc) {
      return doc.clazz = clazz;
    } else {
      return DocumentSetsDocuments.documentsLocks.push({ document_id: id, clazz });
    }
  },

  _onVisiblityToggle(event) {
    event.preventDefault();
    const $this = $(event.currentTarget);
    if ($this.hasClass('pt-lock')) {
      $this.removeClass('pt-lock').addClass('pt-unlock');
      return this._updateDocumentsLocks($this[0].id, 'pt-unlock');
    } else {
      $this.removeClass('pt-unlock').addClass('pt-lock');
      return this._updateDocumentsLocks($this[0].id, 'pt-lock');
    }
  },

  _initializeActions() {
    $(document).on('ajax:success', '.hide-document', _.bind(this._onHideDocument, this));
    $(document).on('click', '.select-document', _.bind(this._onSelectDocument, this));
    $(document).on('click', '#select-all-documents', _.bind(this._onSelectAllDocuments, this));
    $(document).on('click', '#download-documents-action', _.bind(this._onDownloadDocuments, this));
    $(document).on('click', '#move-documents-action', _.bind(this._onMoveDocumentsAction, this));
    $(document).on('click', '#move-category-select', _.bind(this._onSelectCategoryToMove, this));
    $(document).on('click', '#accept-documents-action', _.bind(this._onAcceptDocuments, this));
    $(document).on('click', '#bulk-start-review-documents-action', _.bind(this._onBulkStartReview, this));
    $(document).on('click', '#bulk-destroy-documents-action', _.bind(this._onBulkDestroyDocuments, this));
    $(document).on('click', '#bulk-download-review-action', _.bind(this._onBulkDownloadAndReview, this));
    $(document).on('ajax:success', '.hide-document', _.bind(this._onVisiblityToggle, this));

    const url = new URI(window.location);

    if (url.fragment() === 'redirect_to_download') {
      const params = { selected_ids: url.search(true).selected_ids };
      window.location.hash = '';

      setTimeout(() => {
        return window.location.href = this._buildURLWithParams($('#download-documents-action').attr('href'), params);
      }
        ,
        100);
    }

    if ($('#my-documents-verifier-filter').data('verifier')) {
      return $('#my-documents-verifier-filter').trigger('click');
    } else {
      return $('#default-verifier-filter').trigger('click');
    }
  },

  initializeTable(tableSelector, params) {
    const data = _.map(params, doc => JSON.parse(doc));

    const columnDefs = [
      {
        headerName: 'Task description',
        cellRenderer: doc => escapeHTML(doc.data.partial),
        width: 10000
      },
      {
        headerName: 'title',
        field: 'title',
        hide: true,
        valueGetter(doc) { return doc.data.title; }
      },
      {
        headerName: 'state',
        field: 'state',
        valueGetter(doc) { return doc.data.state; },
        hide: true,
        filter: false
      },
      {
        headerName: 'category',
        field: 'category',
        hide: true,
        valueGetter(doc) { return doc.data.category; },
        filter: 'agTextColumnFilter',
        filterParams: {
          textFormatter(value) { return value; },
          textCustomComparator(filter, value, filterText) {
            return (filterText.lft <= value.lft) && (filterText.rgt >= value.rgt);
          }
        }
      },
      {
        headerName: 'verifier_user',
        field: 'verifier_user',
        hide: true,
        valueGetter(doc) { return doc.data.verifier_user; },
        filter: 'agTextColumnFilter',
        filterParams: {
          textCustomComparator(filter, value, filterText) {
            const filterTextLoweCase = filterText.toLowerCase();
            const valueLowerCase = value.toString().toLowerCase();
            if (filterText === 'my_documents') {
              return valueLowerCase.indexOf(filterTextLoweCase) >= 0;
            } else if (filterText === 'all_documents') {
              const all = valueLowerCase.indexOf(filterTextLoweCase) >= 0;
              const my = valueLowerCase.indexOf('my_documents') >= 0;
              return all + my;
            }
          }
        }
      },
      {
        headerName: 'class_name',
        field: 'class_name',
        hide: true,
        valueGetter(doc) { return doc.data.class_name; },
        comparator: _.bind(this._classNameComparator, this)
      },
      {
        headerName: 'updated_at',
        field: 'updated_at',
        hide: true,
        valueGetter(doc) { return doc.data.updated_at; }
      }
    ];

    this._gridOptions['rowData'] = data;
    this._gridOptions['columnDefs'] = columnDefs;

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;

    $(document).on('click', '.document-filter', _.bind(this._filter, this));
    $(document).on('click', '.document-sort', _.bind(this._sort, this));
    return this._initializeActions();
  },

  _sortValues: {
    'Certificate': 4,
    'FormOfTender': 3,
    'FileDocument': 2,
    'FsDocument': 1,
    'BoqDocument': 0
  },

  _classNameComparator(classNameA, classNameB, nodeA, nodeB, isInverted) {
    return this._sortValues[classNameA] - this._sortValues[classNameB];
  },

  setImportDocumentsDialogEvent(selector) {
    return $(selector).on('click', function (event) {
      event.preventDefault();
      return $('#modalContent').foundation('reveal', 'open', {
        url: $(event.currentTarget).attr('href'),
      });
    });
  },

  initializeBulkActionsForDocumentUploads() {
    $(document).on('change', '[name=check_document]', function () {
      const checkedDocumentsCount = $('[name=check_document]:checked').length;
      return $('#upload-bulk-actions').toggleClass('hidden', checkedDocumentsCount === 0);
    });

    return $(document).on('change', '#bulk_category_select', function () {
      const categoryId = $(this).val();
      const selectsToChange = $('[name=check_document]:checked').parents('.uploadrow')
        .find('.document_category_select:visible');
      selectsToChange.val(categoryId);
      return $(this).val('');
    });
  }
};
